module.exports = __webpack_public_path__ + "img/15_28.d06bf78f.png";